"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 10 10",
  ref: ref
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ursa-icon__75d77a50a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  d: "M5 8.11 2.74 9.25a.462.462 0 0 1-.661-.499l.471-2.533L.823 4.343a.463.463 0 0 1 .28-.773L3.5 3.252 4.583.965a.461.461 0 0 1 .835 0l1.08 2.287 2.4.318c.371.05.533.497.28.773L7.45 6.218l.472 2.533a.462.462 0 0 1-.662.499z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m5 1.72-.866 1.83a.7.7 0 0 1-.54.395l-1.948.258 1.419 1.54a.7.7 0 0 1 .173.602l-.384 2.062 1.83-.923a.7.7 0 0 1 .631 0l1.83.923-.383-2.062a.7.7 0 0 1 .173-.602l1.419-1.54-1.947-.258a.7.7 0 0 1-.541-.395zM3.95.666a1.16 1.16 0 0 1 2.1 0l.919 1.942 2.021.268c.936.124 1.338 1.25.702 1.941l-1.49 1.617.408 2.189c.175.942-.803 1.687-1.665 1.252L5 8.894l-1.945.98c-.862.435-1.84-.31-1.665-1.251l.408-2.189-1.49-1.617C-.328 4.127.074 3 1.01 2.876l2.022-.268z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ursa-icon__75d77a50a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h10v10H0z"
}))));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StarOutlineIcon10.js.map